var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7102 3.80731L47.4337 32.9676C47.9853 33.9297 48.2759 35.0196 48.2759 36.1287C48.2759 39.6377 45.4315 42.4828 41.9228 42.4828H6.35332C2.84446 42.4828 0 39.6377 0 36.1287C0 35.0196 0.290357 33.9297 0.842151 32.9676L17.5657 3.80731C18.9163 1.45239 21.4234 0 24.1379 0C26.8525 0 29.3596 1.45239 30.7102 3.80731ZM27.21 11.7369C27.21 10.0401 25.8346 8.66454 24.1379 8.66454C22.4413 8.66454 21.0658 10.0401 21.0658 11.7369V23.2434C21.0658 24.9402 22.4413 26.3157 24.1379 26.3157C25.8346 26.3157 27.21 24.9402 27.21 23.2434V11.7369ZM27.21 31.9525C27.21 30.2557 25.8346 28.8801 24.1379 28.8801C22.4413 28.8801 21.0658 30.2557 21.0658 31.9525V32.9952C21.0658 34.6921 22.4413 36.0677 24.1379 36.0677C25.8346 36.0677 27.21 34.6921 27.21 32.9952V31.9525Z",
    fill: "#F73F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.81e2776336b2dfd290bc5c131eed0456.svg";
export { ForwardRef as ReactComponent };